import React, { useState } from "react";

// reactstrap components
import {
  Container,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import Toast from "react-bootstrap/Toast";
import { register, registerCand } from "../../network/ApiAxios";
import config from "../../config";
import { PencilAltIcon } from "@heroicons/react/outline";
import Select from "react-select";
import HomepageLayout from "layouts/HomepageLayout.js";



import Register from "components/Auth/register";


const RegisterView = (props) => {
 


  return (
    <>
      <HomepageLayout />

      <Container fluid>
      <Row className="justify-content-center mt-8">
        <Register />
      </Row>
      </Container>
    


    </>
  );
};

export default RegisterView;
